module.exports = __webpack_public_path__ + "assets/94f1e7200b34a5aa3ea30cb694525ae4.mp3";